import React from 'react'
import { Box, Text } from '@chakra-ui/react'

export const ASK_CHCKVET_BETA_HEADLINE =
    "You've been selected for the Ask Chckvet beta"

export const ASK_CHCKVET_BETA_BODY =
    "Ask questions about this screen, a client, or a setting. Ask Chckvet reads your live clinic configuration, explains what's going on, and can propose changes for you to review and apply."

export const ASK_CHCKVET_BETA_PRICING =
    'Completely free to use while in Beta.'

/**
 * First-open notice in an empty thread.
 */
export function AskChckvetBetaNotice() {
    return (
        <Box
            bg="brand.50"
            borderWidth={1}
            borderColor="brand.100"
            rounded="lg"
            px={3}
            py={3}
            mb={4}
        >
            <Text fontWeight="semibold" fontSize="sm" mb={2}>
                {ASK_CHCKVET_BETA_HEADLINE}
            </Text>
            <Text fontSize="sm" color="gray.600">
                {ASK_CHCKVET_BETA_BODY}
            </Text>
            <Text fontSize="sm" color="gray.600" mt={2}>
                {ASK_CHCKVET_BETA_PRICING}
            </Text>
        </Box>
    )
}
